import { useEffect, useState } from "react";
import { generateOnlineBillLink } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { ManualPaymentForm, NoValidateForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { BankGateWayLogo, ImageWarningContainer, InfoText, PaymentGatewayContainer } from "./styles";
import CustomSelect from "../../components/_common/CustomSelect";
import { buySMSCreditOptions } from "../../constants";
import { CreditCardFilled, WarningFilled } from '@ant-design/icons';
import { Console } from "console";
import { PngImage } from "../../components/_common/PngImage";
import { isChrome, isFirefox } from 'react-device-detect';
import { useAppSelector } from "../../redux/store/storehooks";

export const BuySMSCreditDialog: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {

    const myStore = useAppSelector((state) => state)
    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(NoValidateForm) as any
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [dialogStatus, setdialogStatus] = useState(0);
    const [selectedGateway, setSelectedGateway] = useState<any>([]);
    const [itemSMSCred, setItemSms] = useState(buySMSCreditOptions);
    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type];
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect(() => {
        setItems()

        if (payLoad.bill !== null && payLoad.onlinePaymentGateway !== null) setIsLoading(false);
    }, [payLoad])

    const onGatewayClick = (x: any) => {

        if (!values.creditAmount) {
            errorNotify("انتخاب مبلغ شارژ اجباری می باشد", undefined, 5000)
            return;
        }

        setSelectedGateway(x)
        setdialogStatus(1);
    }
    const setItems = () => {
        
        // به علت تعدد خرید در ماه پرداخت شما توسط مدیر غیر فعال شده لطفا با شرکت تماس بگیرید
        let minItem = +myStore.auth.int_minimumpayment;
        if (minItem > 0) {
            errorNotify("سقف پرداخت مرکز شما به علت تعدد خرید توسط حسابداری تغییر پیدا کرده است", undefined, 5000)
           
            let filter = buySMSCreditOptions.filter(item => {
                return item.id > minItem
            })
            let model: any = { id: minItem, title: `${(minItem/10).toLocaleString()} تومان` }
            filter.unshift(model)
            setItemSms(filter)
        }
        else if (minItem == 0) {
            setItemSms(buySMSCreditOptions)
        }
        else {
            let data = new Array<any>();
            errorNotify("به علت تعدد خرید در ماه پرداخت شما توسط مدیر غیر فعال شده لطفا با شرکت تماس بگیرید", undefined, 5000)
            setItemSms(data)
        }



    }

    const redirectToBankGateway = (e: any) => {
        e.preventDefault();

        setIsSubmiting(true)

        generateOnlineBillLink(
            0,
            Number(myStore.auth.loginType === 'labuser' ? myStore.auth.userId : 0),
            selectedGateway.str_GUID,
            Number(values.creditAmount)
        )
            .then((result: any) => {
                sucessNotify("در حال انتقال به درگاه پرداخت آنلاین", undefined, 5000)
                setIsSubmiting(false)
                onCancel();
                window.location.replace(result.data.data);
                console.log(result)
            })
            .catch((error) => {
                console.log(error);
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })


    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>

                {isLoading === true && (
                    <Spinner />
                )}

                {isLoading === false && (

                    <>
                        {dialogStatus === 0 && (
                            <FormContainer title="خرید شارژ پیامک" saveButtonTitle={""} onSubmit={undefined} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >


                                <Row>
                                    <Col>
                                        <WarningFilled style={{ color: 'orange', fontSize: '16px' }} />
                                    </Col>

                                    <Col lg={23} md={23} sm={23} xs={23}>
                                        <InfoText>{"به دلیل ابلاغیه اداره مالیات ، خرید شارژ پیامک زیر 2 میلیون تومن و بیشتر از 4 مرتبه خرید در سال برای هر آزمایشگاه امکان پذیر نمی باشد"}</InfoText>
                                    </Col>

                                </Row>

                                <Row>
                                    <Col>
                                        <CreditCardFilled style={{ color: 'green', fontSize: '16px' }} />
                                    </Col>

                                    <Col lg={23} md={23} sm={23} xs={23}>
                                        <InfoText>{"برای پرداخت ، بعد از انتخاب مبلغ مورد نظر ، بر روی آیکن یکی از درگاه های بانکی زیر کلیک نمایید"}</InfoText>
                                    </Col>

                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomSelect
                                            name="creditAmount"
                                            placeholder="مبلغ شارژ"
                                            itemList={itemSMSCred}
                                            value={values.creditAmount || ""}
                                            onChange={handleChange}
                                            valueObjectField={"id"}
                                            displayObjectField={"title"}
                                        />
                                        <ValidationType type="creditAmount" />
                                    </Col>
                                </Row>

                                <Row>
                                    {(+myStore.auth.int_minimumpayment) != -1 && (

                                        <PaymentGatewayContainer >
                                            <Row>
                                                {payLoad.onlinePaymentGateway !== undefined && (
                                                    payLoad.onlinePaymentGateway.map((x: any) => {
                                                        return (
                                                            <Col >
                                                                <BankGateWayLogo title={x.str_PSPName} alt={x.str_PSPName} onClick={() => onGatewayClick(x)} src={'data:image/jpeg;base64,' + x.str_Logo}></BankGateWayLogo>
                                                            </Col>
                                                        )
                                                    })
                                                )}
                                            </Row>
                                        </PaymentGatewayContainer>

                                    )}
                                    {(+myStore.auth.int_minimumpayment) == -1 && (

                                        <div style={{ color: 'red', marginTop: '10px' }}>
                                            به علت تعدد خرید در ماه پرداخت شما توسط مدیر غیر فعال شده لطفا با شرکت تماس بگیرید
                                        </div>

                                    )}
                                </Row>


                            </FormContainer>
                        )}

                        {dialogStatus === 1 && (

                            <FormContainer title="خرید شارژ پیامک" saveButtonTitle={"متوجه شدم! برو به صفحه پرداخت"} onSubmit={redirectToBankGateway} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >

                                <Row>
                                    <Col>
                                        <WarningFilled style={{ color: 'orange', fontSize: '16px' }} />
                                    </Col>

                                    <Col lg={23} md={23} sm={23} xs={23}>
                                        <InfoText>{"حتما توجه داشته باشید بعد از اتمام پرداخت مطابق عکس زیر بر روی قسمت اشاره شده کلیک نمایید."}</InfoText>
                                    </Col>

                                </Row>

                                <Row>
                                    <ImageWarningContainer>
                                        <PngImage src={isFirefox ? "firefoxpayment.png" : "chormepayment.png"} width="409px" height="199px"></PngImage>
                                    </ImageWarningContainer>
                                </Row>


                            </FormContainer>


                        )}

                    </>

                )}
            </>

        </Modal>
    )
}